import type * as core from '../../../../../../../core'

// TODO: fill in the action query
export const query: core.mosaic.Action.Query = {}
